import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-050b40d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "addedit-correspondence-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line2" }, "Correspondence", -1))
const _hoisted_5 = { class: "body-main" }
const _hoisted_6 = { class: "ls-form" }
const _hoisted_7 = { class: "onerow-twocol-wrapper" }
const _hoisted_8 = { class: "colone" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Type *", -1))
const _hoisted_10 = { class: "select-wrapper" }
const _hoisted_11 = { class: "select" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: "",
  selected: ""
}, " -- Select type -- ", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_16 = { class: "coltwo" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date received *", -1))
const _hoisted_18 = { class: "date-picker" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Description *", -1))
const _hoisted_21 = { class: "select-wrapper" }
const _hoisted_22 = { class: "select" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: "",
  selected: ""
}, " -- Select description -- ", -1))
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "If other, please specify *", -1))
const _hoisted_28 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Attach Correspondence *", -1))
const _hoisted_31 = { class: "existing-file" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Maximum file size: 100MB", -1))
const _hoisted_34 = {
  key: 3,
  class: "validation-msg"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_36 = { class: "controls mt-4" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))
const _hoisted_40 = {
  key: 0,
  class: "delete-correspondence"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "DELETE ALERT", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Are you sure you want to delete the correspondence?", -1))

export function render(_ctx, _cache) {
  const _component_v3_date_picker = _resolveComponent("v3-date-picker")
  const _component_FileDragAndDrop = _resolveComponent("FileDragAndDrop")
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")
  const _component_AlertBox = _resolveComponent("AlertBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[9] || (_cache[9] = $event => (_ctx.closeModal())),
      halfScreen: true
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.editMode ? 'Edit correspondence' : 'Add correspondence'), 1),
          _hoisted_4
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", _hoisted_6, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.formData.correspondenceType) = $event))
                      }, [
                        _hoisted_12,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.correspondenceType, (cT) => {
                          return (_openBlock(), _createElementBlock("option", { value: cT }, _toDisplayString(cT.name), 9, _hoisted_13))
                        }), 256))
                      ], 512), [
                        [_vModelSelect, _ctx.formData.correspondenceType]
                      ])
                    ])
                  ]),
                  (!_ctx.formData.correspondenceType)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _hoisted_15,
                        _createTextVNode(" Mandatory field ")
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_v3_date_picker, {
                      class: "v3-date-picker",
                      style: {"padding":"1em"},
                      modelValue: _ctx.dateReceived,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.dateReceived) = $event)),
                      inputFormat: "dd-MM-yyyy"
                    }, null, 8, ["modelValue"]),
                    _hoisted_19
                  ])
                ])
              ]),
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.formData.correspondenceDescription) = $event))
                  }, [
                    _hoisted_23,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.correspondenceDescriptions, (cD) => {
                      return (_openBlock(), _createElementBlock("option", { value: cD }, _toDisplayString(cD.name), 9, _hoisted_24))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.formData.correspondenceDescription]
                  ])
                ])
              ]),
              (!_ctx.formData.correspondenceDescription)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    _createTextVNode(" Mandatory field ")
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.correspondenceDescription?.id == 13)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_27,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.formData.description) = $event)),
                      style: {"resize":"vertical"}
                    }, null, 512), [
                      [_vModelText, _ctx.formData.description]
                    ]),
                    (!_ctx.formData.description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _hoisted_29,
                          _createTextVNode(" Mandatory field ")
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _hoisted_30,
              (_ctx.formData.file)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.formData.file.fileName), 1),
                      _createElementVNode("div", null, [
                        (!_ctx.allowFileOverwrite)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-default sml",
                              onClick: _cache[4] || (_cache[4] = _withModifiers($event => (_ctx.allowFileOverwrite = !_ctx.allowFileOverwrite), ["prevent"]))
                            }, "Undo"))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn-default sml",
                              onClick: _cache[5] || (_cache[5] = _withModifiers($event => (_ctx.allowFileOverwrite = !_ctx.allowFileOverwrite), ["prevent"]))
                            }, "Delete"))
                      ])
                    ]),
                    _hoisted_32
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_FileDragAndDrop, {
                disabled: _ctx.formData.file && _ctx.allowFileOverwrite,
                numFileLimit: 1,
                fileSizeLimit: 100,
                onFileInputChanged: _ctx.correspondenceChanged,
                acceptAnyFileTypes: _ctx.acceptAnyFileTypes
              }, _createSlots({ _: 2 }, [
                (_ctx.formData.file)
                  ? {
                      name: "disabled-message",
                      fn: _withCtx(() => [
                        _createTextVNode(" You must delete current file before upload new' once any are uploaded, or if ones were previously uploaded ")
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["disabled", "onFileInputChanged", "acceptAnyFileTypes"]),
              _hoisted_33,
              (_ctx.editMode ? (_ctx.formData.file && !this.allowFileOverwrite && _ctx.fileList?.length == 0) : _ctx.fileList?.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _hoisted_35,
                    _createTextVNode(" Mandatory field ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("button", {
            class: "btn btn-default ml-1",
            disabled: _ctx.submitting,
            onClick: _cache[6] || (_cache[6] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
          }, " Back ", 8, _hoisted_37),
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: _ctx.submitting || !(_ctx.isFormDirty && _ctx.validForm),
            onClick: _cache[7] || (_cache[7] = _withModifiers($event => (_ctx.saveCorrespondence()), ["prevent","stop"]))
          }, [
            _createTextVNode(_toDisplayString(_ctx.editMode? 'Save changes' : 'Add correspondence'), 1),
            _hoisted_39
          ], 8, _hoisted_38),
          (_ctx.submitting)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                class: "loading-indicator",
                showLoadingText: false
              }))
            : _createCommentVNode("", true)
        ]),
        (_ctx.editMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _createTextVNode(" Or "),
              _createElementVNode("a", {
                class: "link2",
                onClick: _cache[8] || (_cache[8] = $event => (_ctx.showDeleteAlert = true))
              }, "delete correspondence")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.showDeleteAlert)
      ? (_openBlock(), _createBlock(_component_AlertBox, {
          key: 0,
          onClose: _cache[12] || (_cache[12] = $event => (_ctx.showDeleteAlert = false))
        }, {
          header: _withCtx(() => [
            _hoisted_41
          ]),
          body: _withCtx(() => [
            _hoisted_42
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-tertiary",
              onClick: _cache[10] || (_cache[10] = $event => (_ctx.showDeleteAlert = false))
            }, "Cancel"),
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[11] || (_cache[11] = (...args) => (_ctx.yesClicked && _ctx.yesClicked(...args)))
            }, "Delete")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}